import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { campusLifeData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import { MoreToggle, useIsMobile } from "../../components/ShowMore";
import "./homeRedesign.css";

// "Life at NCET" — 8 image cards, 4 per row. Desktop (>991px) shows all 8.
// Tablet/phone (<=991px) shows the first 4 and reveals the rest via "Load All",
// keeping the section compact and deferring the heavy images on small screens.
const INITIAL = 4;

const CampusLifeSection = ({ data }) => {
  const { eyebrow, heading, subtitle, social, clubs } = data || campusLifeData;
  const [showAll, setShowAll] = useState(false);
  const clampScreen = useIsMobile("(max-width: 991px)"); // true on tablet/phone

  const cardInner = (club) => (
    <>
      <img className="campus-ed__img" src={mediaUrl(club.image)} alt={club.name} loading="lazy" />
      <span className="campus-ed__overlay" aria-hidden="true" />
      <div className="campus-ed__social">
        <a href={social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
        <a href={social.twitter} target="_blank" rel="noreferrer" aria-label="X (Twitter)"><FontAwesomeIcon icon={faXTwitter} /></a>
        <a href={social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
      </div>
      <h3 className="campus-ed__name"><span>{club.name}</span></h3>
    </>
  );

  const base = clubs.slice(0, INITIAL);
  const extra = clubs.slice(INITIAL);

  return (
    <section className="campus-ed" aria-labelledby="campus-ed-title">
      <div className="container">
        <div className="section-head-ed">
          <span className="eyebrow-ed">{eyebrow}</span>
          <h2 id="campus-ed-title" className="heading-ed">{heading}</h2>
          <p className="section-sub-ed">{subtitle}</p>
        </div>

        <div className="campus-ed__grid">
          {base.map((club, i) => (
            <article className="campus-ed__card" key={i}>{cardInner(club)}</article>
          ))}

          {!clampScreen ? (
            // desktop: all extra cards always visible
            extra.map((club, i) => (
              <article className="campus-ed__card" key={`e-${i}`}>{cardInner(club)}</article>
            ))
          ) : (
            // tablet/phone: reveal extras via "Load All"
            <AnimatePresence>
              {showAll &&
                extra.map((club, i) => (
                  <motion.article
                    className="campus-ed__card"
                    key={`x-${i}`}
                    initial={{ opacity: 0, y: 26, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 18, scale: 0.97 }}
                    transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1], delay: i * 0.07 }}
                  >
                    {cardInner(club)}
                  </motion.article>
                ))}
            </AnimatePresence>
          )}
        </div>

        {clampScreen && extra.length > 0 && (
          <MoreToggle
            open={showAll}
            onClick={() => setShowAll((o) => !o)}
            moreLabel={`Load All (${extra.length} more)`}
            lessLabel="Show Less"
          />
        )}
      </div>
    </section>
  );
};

export default CampusLifeSection;
